import "@albelli/arc-3/lib/core.css";
import "@albelli/arc-3/lib/icon.css";
import { ChangeEmailSuccess } from "components/changeEmail/ChangeEmailSuccess/ChangeEmailSuccess";
import { AuthenticatedApp } from "components/common/AuthenticatedApp/AuthenticatedApp";
import { Bootstrap } from "components/common/Bootstrap/Bootstrap";
import { ErrorBoundary } from "components/common/ErrorBoundary/ErrorBoundary";
import { ScrollToTop } from "components/common/ScrollToTop/ScrollToTop";
import { AccountDeleted } from "components/deleteAccount/AccountDeleted/AccountDeleted";
import { indexReducer } from "indexReducer";
import { indexSaga } from "indexSaga";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import ReduxThunk from "redux-thunk";
import { routes } from "routes";
import { NewRelicErrorHandler, rejectionMiddleware } from "services/errorService";

//window.newrelic will be null if blocked by an addblocker
window && window.newrelic && window.newrelic.setErrorHandler(NewRelicErrorHandler);
window && window.newrelic && window.newrelic.setCustomAttribute("Referrer", document.referrer);

const sagasMiddleware = createSagaMiddleware();
const composeEnhancer =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const store = createStore(
  indexReducer,
  composeEnhancer(applyMiddleware(rejectionMiddleware, sagasMiddleware, ReduxThunk))
);

sagasMiddleware.run(indexSaga);

export const App = () => {
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <BrowserRouter>
          <LastLocationProvider>
            <ScrollToTop>
              <Bootstrap>
                <Switch>
                  <Route path={routes.accountDeleted} component={AccountDeleted} />
                  <Route path={routes.changeEmailSuccess} component={ChangeEmailSuccess} />
                  <Route component={AuthenticatedApp} />
                </Switch>
              </Bootstrap>
            </ScrollToTop>
          </LastLocationProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </Provider>
  );
};
export default App;
